import styled from 'styled-components';

import { theme } from '@styles/theme';

export const STATUS_LINE_VARIANTS = ['blue', 'green', 'red', 'orange'] as const;

type StatusLineVariant = (typeof STATUS_LINE_VARIANTS)[number];

export type StatusLineProps = {
  variant: StatusLineVariant;
};

export function StatusLine(props: StatusLineProps) {
  const { variant } = props;

  return <StyledStatusLine className="status-line" $variant={variant} />;
}

const StyledStatusLine = styled.div<{ $variant: StatusLineVariant }>((p) => ({
  height: '100%',
  width: '0.25rem',
  borderRadius: '0.25rem',
  backgroundColor: theme.color[`${p.$variant}100`],
  flexShrink: 0,
}));
